<script setup lang="ts">
</script>
<template>
  <div class="wrapper">
    <svg
      ref="btn"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9153 3.31085L16.6989 5.11307M17.6332 2.38617C17.8711 2.634 18.0028 2.96609 18 3.31085C17.9971 3.65561 17.86 3.98545 17.618 4.22928L11.3868 10.5075L9 11.1451L9.60209 8.70938L15.8369 2.37448C16.0561 2.15194 16.3494 2.0192 16.6601 2.00193C16.9708 1.98465 17.2768 2.08408 17.519 2.28098L17.6332 2.38617Z"
        stroke="#747474"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.2248 4.01249C14.151 4.00424 14.076 4 14 4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H14C15.1046 18 16 17.1046 16 16V6C16 5.95432 15.9985 5.909 15.9955 5.86408L14.5 7.37082V16C14.5 16.2761 14.2761 16.5 14 16.5H4C3.72386 16.5 3.5 16.2761 3.5 16V6C3.5 5.72386 3.72386 5.5 4 5.5H12.7608L14.2248 4.01249ZM11.2403 7.04492H4.96191V8.54492H9.76395L11.2403 7.04492ZM9.27196 10.0449H4.96191V11.5449H12.9619V10.0449H11.8459L11.3868 10.5075L9 11.1451L9.27196 10.0449ZM9.96191 14.5449H4.96191V13.0449H9.96191V14.5449Z"
        fill="#747474"
      />
    </svg>
  </div>
</template>
<style scoped>
svg {
  flex-shrink: 0;
}
.wrapper {
  display: flex;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}
</style>
